<template>
 <div class="container">
   <!-- 公司信息 -->
   <div class="supplier-info box">
     <div class="supplier-info-top">
       <mechanism></mechanism>
     </div>
   </div>
 </div>
</template>

<script>
 import mechanism from '../../components/SettleFlod/Mechanism'
export default {
  name: "company",
  components:{
    mechanism
  }
}
</script>
<style>
.myTool {
  border: 1px solid #ebeef5 !important;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  word-break: break-all;
  width: 320px;
}
</style>
<style lang="scss" scoped>
    .top-fill /deep/.el-tooltip {
      text-decoration: underline;
      color: white;
      font-size: 12px;
      position: relative;
      top: 10px;
      left: 8px;
    }
    .container {

      .top-fill {
        display: flex;
        padding-left: 10px;
        //width: 12.8rem;
        background: var(--color);
        height: 35px;
        border-radius: 10px 10px 0 0;
        margin: 0 auto;
        .svgIcon {
          color: white;
          height: 0.23rem;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
        >h3 {
          display: flex;
          align-items: center;
          color: white;
        }
      }
    }
</style>